import React from "react";
import { RouteDefinition } from "utilities/interfaces/route-definition";
import { NestedRoutes } from "utilities/routing/nested-route";
import UnauthenticatedLayout from "./unauthenticated-layout";
import AuthenticatedNonSubscriberLayout from "./authenticated-non-subscriber-layout";
import AuthenticatedSubscriberLayout from "./authenticated-subscriber-layout";
import useCurrentIdentity from "utilities/hooks/use-current-identity";

interface ShareSpaceRecipientLayoutProps {
    routes?: RouteDefinition[];
}

export const SHARE_RECIPIENT_BASE_CLASS = "c-share-space-recipient-layout";

const ShareSpaceRecipientLayout: React.FunctionComponent<
    ShareSpaceRecipientLayoutProps
> = (props: ShareSpaceRecipientLayoutProps) => {
    const { isLoggedIn, currentIdentity } = useCurrentIdentity();

    const LayoutTemplate = isLoggedIn
        ? currentIdentity?.hasActiveSubscription()
            ? AuthenticatedSubscriberLayout
            : AuthenticatedNonSubscriberLayout
        : UnauthenticatedLayout;

    return (
        <LayoutTemplate>
            <section className={`${SHARE_RECIPIENT_BASE_CLASS}__content`}>
                <NestedRoutes routes={props.routes!} />
            </section>
        </LayoutTemplate>
    );
};

export default ShareSpaceRecipientLayout;
